(function () {
  const section   = document.querySelector('.vc-teaser-hero');
  if (!section) { console.warn('[Teaser] section not found'); return; }

  const blurOverlay = section.querySelector('[data-video-trigger]');
  const expandBtn   = section.querySelector('[data-expand-form]');
  const form        = section.querySelector('form');
  console.log('[Teaser] init — form:', form ? form.id : 'NOT FOUND');

  const panels      = section.querySelectorAll('[data-form-panel]');
  const cursor      = section.querySelector('[data-cursor]');
  const cursorLabel = section.querySelector('.vc-hero__cursor-label');
  const video       = section.querySelector('video');
  const playerBtn   = section.querySelector('[data-player-btn]');
  const playerBar   = section.querySelector('[data-player-bar]');
  const playerTime  = section.querySelector('[data-player-time]');

  const defaultPanel  = section.querySelector('[data-form-panel="default"]');
  const expandedPanel = section.querySelector('[data-form-panel="expanded"]');
  const formWrap      = section.querySelector('.vc-hero__form-wrap');

  const nameInput      = form && form.querySelector('[name="first_name"]');
  const addressInput   = form && form.querySelector('[name="address"]');
  const pairError      = form && form.querySelector('[data-pair-error]');
  const journalToggle  = form && form.querySelector('[data-journal-toggle]');
  const journalFields  = form && form.querySelector('[data-journal-fields]');

  if (journalToggle && journalFields) {
    journalToggle.addEventListener('change', () => {
      const checked = journalToggle.checked;
      journalFields.hidden = !checked;
      if (nameInput)    nameInput.required    = checked;
      if (addressInput) addressInput.required = checked;
      if (!checked && pairError) pairError.hidden = true;
    });
  }

  function getVisibleAddressInput() {
    const wrap = form && form.querySelector('.vc-places-wrap');
    return (wrap && wrap.querySelector('input')) || addressInput;
  }

  function syncOptionalLabels() {
    if (!nameInput || !addressInput) return;
    const hasName = nameInput.value.trim().length > 0;
    const hasAddr = addressInput.value.trim().length > 0;
    nameInput.placeholder = (hasAddr && !hasName) ? 'Name' : 'Name (optional)';
    const visibleAddr = getVisibleAddressInput();
    if (visibleAddr) visibleAddr.placeholder = (hasName && !hasAddr) ? 'Address' : 'Address (optional)';
    if (pairError) pairError.hidden = true;
  }

  if (nameInput)    nameInput.addEventListener('input', syncOptionalLabels);
  if (addressInput) addressInput.addEventListener('input', syncOptionalLabels);

  if (defaultPanel) {
    defaultPanel.offsetHeight;
    defaultPanel.classList.add('is-visible');
  }

  // On mobile the form-wrap is in flow — lock its height to the expanded panel
  // so layout never shifts when switching panels
  function lockMobileFormHeight() {
    if (window.innerWidth > 991 || !formWrap || !expandedPanel) return;
    formWrap.style.minHeight = expandedPanel.offsetHeight + 'px';
  }

  lockMobileFormHeight();
  window.addEventListener('resize', lockMobileFormHeight);

  function showPanel(name) {
    panels.forEach(p => {
      p.classList.toggle('is-visible', p.dataset.formPanel === name);
    });
  }

  if (expandBtn) {
    expandBtn.addEventListener('click', () => {
      showPanel('expanded');
      const emailInput = section.querySelector('input[type="email"]');
      if (emailInput) emailInput.focus();
    });
  }

  const submitBtn = form && form.querySelector('[type="submit"]');
  if (submitBtn) {
    submitBtn.addEventListener('click', () => {
      if (typeof fbq === 'function') fbq('track', 'Lead', { value: 0, currency: 'GBP' });
    });
  }

  if (form) {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();

      const emailInput = form.querySelector('[name="email"]');
      const submitBtn  = form.querySelector('[type="submit"]');
      const label      = submitBtn && submitBtn.querySelector('.vc-btn__label');

      const email     = (emailInput?.value || '').trim();
      const firstName = (form.querySelector('[name="first_name"]')?.value || '').trim();
      const address   = (form.querySelector('[name="address"]')?.value || '').trim();
      const flat      = (form.querySelector('[name="flat"]')?.value || '').trim();
      if (!email || !emailInput.checkValidity()) {
        emailInput && emailInput.reportValidity();
        return;
      }

      const journalChecked = journalToggle && journalToggle.checked;
      if (journalChecked && (!firstName || !address)) {
        if (pairError) pairError.hidden = false;
        return;
      }

      if (submitBtn) submitBtn.disabled = true;
      if (label) label.textContent = 'Submitting…';

      const profileAttrs = { email };
      if (firstName) profileAttrs.first_name = firstName;
      if (address || flat) {
        profileAttrs.properties = {};
        if (address) profileAttrs.properties.postal_address = address;
        if (flat)    profileAttrs.properties.address_line_2 = flat;
        try {
          if (form.dataset.placeJson) {
            profileAttrs.properties.place_data = JSON.parse(form.dataset.placeJson);
          }
        } catch (e) {}
      }

      const HEADERS = {
        'Content-Type': 'application/vnd.api+json',
        'revision': '2024-10-15'
      };
      const COMPANY = 'VRADCX';
      const LIST_ID = 'VZMqev';

      try {
        // Update profile properties first (subscriptions endpoint doesn't patch custom props)
        if (address || flat) {
          await fetch(`https://a.klaviyo.com/client/profiles/?company_id=${COMPANY}`, {
            method: 'POST',
            headers: HEADERS,
            body: JSON.stringify({
              data: {
                type: 'profile',
                attributes: profileAttrs
              }
            })
          });
        }

        // Subscribe to list
        const res = await fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${COMPANY}`, {
          method: 'POST',
          headers: HEADERS,
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: {
                custom_source: 'Varden Club Teaser',
                profile: { data: { type: 'profile', attributes: profileAttrs } }
              },
              relationships: {
                list: { data: { type: 'list', id: LIST_ID } }
              }
            }
          })
        });

        if (res.ok || res.status === 202) {
          showPanel('thankyou');
          if (typeof fbq === 'function') fbq('track', 'Lead', { value: 0, currency: 'GBP' });
        } else {
          const body = await res.text();
          console.error('[Klaviyo] error:', res.status, body);
          if (label) label.textContent = 'Please try again';
          if (submitBtn) submitBtn.disabled = false;
        }
      } catch (err) {
        console.error('[Klaviyo] fetch error:', err);
        if (label) label.textContent = 'Please try again';
        if (submitBtn) submitBtn.disabled = false;
      }
    });
  }

  function formatTime(s) {
    const m = Math.floor(s / 60);
    const sec = Math.floor(s % 60);
    return `${m}:${sec.toString().padStart(2, '0')}`;
  }

  if (video) {
    video.addEventListener('timeupdate', () => {
      if (!video.duration) return;
      const pct = (video.currentTime / video.duration) * 100;
      if (playerBar) playerBar.style.width = pct + '%';
      if (playerTime) playerTime.textContent = formatTime(video.currentTime);
    });
  }

  if (playerBtn) {
    playerBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      if (!video) return;
      if (video.paused) { video.play(); } else { video.pause(); }
    });
  }

  const player = section.querySelector('[data-player]');
  if (player) {
    player.addEventListener('click', (e) => e.stopPropagation());
  }


  if (cursor) {
    let mx = 0, my = 0, cx = 0, cy = 0, raf = null;

    function tick() {
      cx += (mx - cx) * 0.07;
      cy += (my - cy) * 0.07;
      cursor.style.transform = `translate(${cx}px, ${cy}px)`;
      if (Math.abs(mx - cx) > 0.1 || Math.abs(my - cy) > 0.1) {
        raf = requestAnimationFrame(tick);
      } else {
        raf = null;
      }
    }

    section.addEventListener('mousemove', (e) => {
      const rect = section.getBoundingClientRect();
      mx = e.clientX - rect.left;
      my = e.clientY - rect.top;
      if (!raf) raf = requestAnimationFrame(tick);

      const overForm = formWrap && formWrap.contains(e.target);
      cursor.style.opacity = overForm ? '0' : '1';
    });

    section.addEventListener('mouseleave', () => {
      cursor.style.opacity = '0';
      raf = null;
    });
  }

})();
